import React from 'react';
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from "react-icons/bs";

function ClientsSlider() {


    const slideBrands = () => {
        if (document.getElementsByClassName('spriteImg')[0]) {
            var sprite = document.getElementsByClassName('spriteImg')[0];
            !sprite.style.backgroundPosition ? sprite.style.backgroundPosition = "0px" : console.log();
            var position = parseInt(sprite.style.backgroundPosition)
            position -= 1;
            sprite.style.backgroundPosition = `${position}px`;
        }
        setTimeout(slideBrands, 25);
    }
    slideBrands();

    const slideSlider = (direction = "left") => {
        var element = document.getElementsByClassName('spriteImg')[0];
        var position = parseInt(element.style.backgroundPosition);
        if (direction === 'right') element.style.backgroundPosition = position + 200 + "px";
        else element.style.backgroundPosition = position - 200 + "px"
    }

    return (
        <div className='fullPadding relative'>
            <h2 className='center'>NUESTRA EXPERIENCIA</h2>
            <div className='spriteImg' aria-label="Nuestros clientes: Ara, Tiendas D1, Davivienda, Audifarma, Telemedellín, SaludTotal, Bvc, de lolita, mapfre, Éxito, eps sura, coltefinanciera, tcc, bancolombia"></div>
            {/* Hidden list for SEO/Accessibility since logos are in a sprite */}
            <div className="sr-only" style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
                Ara, Tiendas D1, Davivienda, Audifarma, Telemedellín, SaludTotal, Bvc, de lolita, mapfre, Éxito, eps sura, coltefinanciera, tcc, bancolombia
            </div>
            <span className='sliderIconLeft' onClick={() => slideSlider('left')}><BsFillArrowLeftCircleFill /></span>
            <span className='sliderIconRight' onClick={() => slideSlider('right')}><BsFillArrowRightCircleFill /></span>
        </div>
    )
}

export default ClientsSlider